/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationCreateStatusChangeDto } from '../models/NotificationCreateStatusChangeDto';
import type { NotificationDto } from '../models/NotificationDto';
import type { NotificationReadAtByIdRequest } from '../models/NotificationReadAtByIdRequest';
import type { NotificationSearchRequest } from '../models/NotificationSearchRequest';
import type { PaginatedNotificationDto } from '../models/PaginatedNotificationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class NotificationService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns NotificationDto OK
     * @throws ApiError
     */
    public shopSetReadAt({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: NotificationReadAtByIdRequest,
    }): CancelablePromise<NotificationDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/notification/shop/{shopId}/read',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns NotificationDto OK
     * @throws ApiError
     */
    public shopSetReadAtAll({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<Array<NotificationDto>> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/notification/shop/{shopId}/read-all',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns NotificationDto OK
     * @throws ApiError
     */
    public financierSetReadAt({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: NotificationReadAtByIdRequest,
    }): CancelablePromise<NotificationDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/notification/financier/{financierId}/read',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns NotificationDto OK
     * @throws ApiError
     */
    public financierSetReadAtAll({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<Array<NotificationDto>> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/v2/notification/financier/{financierId}/read-all',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedNotificationDto OK
     * @throws ApiError
     */
    public shopSearchNotification({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: NotificationSearchRequest,
    }): CancelablePromise<PaginatedNotificationDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/notification/shop/{shopId}/search',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public shopNotificationChangeStatus({
        shopId,
        requestBody,
    }: {
        shopId: string,
        requestBody: NotificationCreateStatusChangeDto,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/notification/shop/{shopId}/create/status-change',
            path: {
                'shopId': shopId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedNotificationDto OK
     * @throws ApiError
     */
    public financierSearchNotification({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: NotificationSearchRequest,
    }): CancelablePromise<PaginatedNotificationDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/notification/financier/{financierId}/search',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public financierNotificationChangeStatus({
        financierId,
        requestBody,
    }: {
        financierId: string,
        requestBody: NotificationCreateStatusChangeDto,
    }): CancelablePromise<Record<string, any>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/notification/financier/{financierId}/create/status-change',
            path: {
                'financierId': financierId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns number OK
     * @throws ApiError
     */
    public shopSearchCountNotificationNoRead({
        shopId,
    }: {
        shopId: string,
    }): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/notification/shop/{shopId}/search/count-no-read',
            path: {
                'shopId': shopId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns number OK
     * @throws ApiError
     */
    public financierSearchCountNotificationNoRead({
        financierId,
    }: {
        financierId: string,
    }): CancelablePromise<number> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/notification/financier/{financierId}/search/count-no-read',
            path: {
                'financierId': financierId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
